export default __webpack_public_path__ + "static/media/710.1f3d4e51.png";